import { render, staticRenderFns } from "./YandexBlocker.vue?vue&type=template&id=20641552&"
import script from "./YandexBlocker.vue?vue&type=script&lang=js&"
export * from "./YandexBlocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports